import { memo, ReactElement } from 'react';
import { UpgradeModule } from '../components/UpgradeModule';
import { CurrentHealthContainer, HealthContainer } from './styles';
import { HealthUnitsInfo } from './components/UnitsInfo';
import { HealthHistoryCard } from './HistoryCard';
import { GeoMap } from '../Map';
import { useFilterContext } from '../contexts/FilterContext';

interface HealthProps {
  order: number;
  hasHealth: boolean;
  loading: boolean;
}

function HealthComponent({
  order,
  hasHealth,
  loading,
}: Readonly<HealthProps>): ReactElement {
  const { client } = useFilterContext();
  return (
    <HealthContainer style={{ order }}>
      {!hasHealth && !loading && (<UpgradeModule module="health" />)}
      <CurrentHealthContainer>
        <HealthUnitsInfo
          hasHealth={hasHealth}
          loading={loading}
        />
        <HealthHistoryCard
          hasHealth={hasHealth}
          loading={loading}
        />
      </CurrentHealthContainer>
      <GeoMap key={client || 'no-client'} hasHealth={hasHealth} loading={loading} />
    </HealthContainer>
  );
}

export const Health = memo(HealthComponent, (prev, next) => (
  prev.hasHealth === next.hasHealth
    && prev.loading === next.loading
    && prev.order === next.order
));
